export default () => {
  if (document.getElementById('order_shipping_method_id')) {
    document.getElementById('order_shipping_method_id').addEventListener('change', e => {
      document.getElementById('validate').click();
    });
  }
};
